import { ACCENT_BLUE, NOPING_GREEN } from '../constants';

export function PingGridBg() {
  return (
    <div className='pointer-events-none absolute inset-0 overflow-hidden' aria-hidden='true'>
      <div className='absolute start-1/4 top-1/4 size-96 rounded-full blur-[120px]' style={{ background: `${ACCENT_BLUE}18` }} />
      <div className='absolute bottom-1/4 end-1/4 size-80 rounded-full blur-[100px]' style={{ background: `${NOPING_GREEN}12` }} />
      <div className='absolute inset-0 opacity-[0.03]' style={{ backgroundImage: `radial-gradient(${ACCENT_BLUE} 1px, transparent 1px)`, backgroundSize: '40px 40px' }} />
    </div>
  );
}
